import { useStateWrapper } from '../../../../hooks'
import { GET_ASSIGNMENTS } from '../../../../graphql'
import { AssignmentsQueryType } from '../../../../types/types'
import { OrganizationalRoles, StaffRepresentativeRoles } from './components'

export const AssignmentInfo = () => {
  const { StateRenderWrapper, data } = useStateWrapper<AssignmentsQueryType>({
    query: GET_ASSIGNMENTS
  })

  return (
    <StateRenderWrapper>
      <OrganizationalRoles
        organizationalRoles={data?.assignments.jarjestotehtavat}
      />
      <StaffRepresentativeRoles
        staffRepresentativeRoles={data?.assignments.luottamustehtavat}
      />
    </StateRenderWrapper>
  )
}
